import { createReducer } from 'typesafe-actions';
import { UnifiedCompareState } from '../types';
import { PRODUCTS_COMPARE_MANAGE, PRODUCTS_COMPARE_LOAD_DATA, AllProductsCompareActions } from '../actions';

export const unifiedCompareData = createReducer<UnifiedCompareState, AllProductsCompareActions>({})
  .handleAction(PRODUCTS_COMPARE_MANAGE.success, (_, { payload }) => ({
    ...payload,
  }))

  // NOTE: Возвращает состояние до ошибки, так как у нас positive update.
  .handleAction(PRODUCTS_COMPARE_MANAGE.failure, (_, { payload }) => {
    const { currentState } = payload;
    return {
      ...currentState,
    };
  })

  .handleAction(PRODUCTS_COMPARE_LOAD_DATA.success, (state, { payload }) => {
    const { groupId, productsData } = payload;
    const currentGroup = state?.[groupId];

    if (!currentGroup) {
      return state;
    }

    const updatedProductsData = { ...currentGroup.productsData };

    Object.entries(productsData).forEach(([productId, fullProductData]) => {
      updatedProductsData[productId] = fullProductData;
    });

    return {
      ...state,
      [groupId]: {
        ...currentGroup,
        productsData: updatedProductsData,
        isDataLoaded: true,
      },
    };
  });
